import { createUseStyles } from "react-jss";
import { foregroundColor } from "../../theme/Mixins";

export default createUseStyles({
    select: ({ theme }) => ({
        boxShadow: `0 0 0 ${theme.BorderWidth}px ${theme.ControlBorderColor} inset`,
        borderRadius: theme.BorderRadius,
        background: theme.ControlBackground,
        color: foregroundColor(theme, theme.ControlBackground),
        padding: [[1, 4]],
        lineHeight: "1.6em",
        border: 0,
        margin: "10px",
    }),
});
